import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { Dependencies } from '@adornis/materialized-views/decorators/dependency.js';
import { iban } from '@adornis/validation/functions/iban.js';

@Entity()
export class BankDaten extends AdornisEntity {
  static override _class = 'BankInfos';

  constructor(doc: PartialEntityData<BankDaten>) {
    super(doc);
  }

  @Field(() => String)
  iban: Maybe<string>;

  /**
   * This is an accounting field which is mostly automated. It tracks legacy ibans when users change them in the portal.
   * With this users can still download quittungen with the legacy ibans. It can also be controlled by the accounting personal to restrict access to an old iban,
   * in the case of child custody agreements.
   */
  @Field(() => [String], { default: v => v ?? [] })
  legacyIbans: Maybe<string[]>;

  /** kann auch abweichender Kontoinhaber sein */
  @Field(() => String)
  kontoinhaber: Maybe<string>;

  @Field(() => Boolean, { default: v => v ?? false })
  nichtSepa: Maybe<boolean>;

  @Field(() => String)
  nichtSepaLand: Maybe<string>;

  @Field(() => String)
  nichtSepaKreditinstitut: Maybe<string>;

  @Field(() => String)
  nichtSepaOrt: Maybe<string>;

  @Field(() => String)
  nichtSepaSWIFT: Maybe<string>;

  @Field(() => String)
  nichtSepaIBAN: Maybe<string>;

  @Field(() => String)
  nichtSepaLaenderschluessel: Maybe<string>;

  @Dependencies({
    classes: () => [],
    ids: () => [],
  })
  @Field(() => Boolean, {
    resolve: function (this: BankDaten) {
      return async () => {
        let ibanWrong = false;

        try {
          await iban({ allowEmpty: true })({
            value: this.iban,
            key: 'iban',
            target: this,
          });
        } catch {
          ibanWrong = true;
        }

        return ibanWrong;
      };
    },
  })
  ibanWrong: Maybe<boolean>;
}
